import usePortalModal from 'hooks/usePortalModal.jsx';
import { functionUtils } from 'utils/func.js';
import Popup from './popup';

const ETAIframeModal = ({
  isShow,
  modalStyles,
  modalOptions,
  actionClose,
  action,
}) => {
  const { closePortalModalName } = usePortalModal();

  const isBackdropOverlap = !modalOptions?.isFullScreenWithHeader;

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    closePortalModalName();
  };

  return (
    <Popup
      isOpen={isShow}
      modalStyles={modalStyles}
      modalOptions={modalOptions}
      onClose={handleOnClose}
      onClick={handleOnClick}
      isBackdropOverlap={isBackdropOverlap}
      zIndexBackdropOverlap={1075}
      zIndexModal={1076}
    />
  );
};

export default ETAIframeModal;
